import { sharedConfig } from '@/pageConfig/shared';
import { DocumentTypes } from 'contentlayer/generated';
import content from '../../../../.contentlayer/generated/TermsOfService/termsOfService__en-US.mdx.json';
import type { BasePageConfig } from '../../BasePageConfig';

export type Config = BasePageConfig;

export const config: Config = {
  layout: { ...sharedConfig['en-US'].layout },
  seo: {
    ...sharedConfig['en-US'].seo,
    title: 'Lemonade: Terms of Service ',
    metaTitle: 'Lemonade: Terms of Service ',
    description:
      'Read Lemonade’s Terms of Service for detailed information on user obligations and access conditions to our insurance platform.',
  },
  MDXContent: content as DocumentTypes,
};
